const drawerMenulinks = document.querySelectorAll('.menu-drawer__menu details .menu-drawer__main-item');
const drawerSubmenus = document.querySelectorAll('.menu-drawer__menu details .menu-drawer__submenu');
const miniSubmenuContainer = document.querySelector('.mini-submenu-container');
const drawerDetails = document.querySelectorAll('.menu-drawer__menu .menu-drawer-submenu-main');
{
    drawerSubmenus.forEach( drawer => {
        drawer.classList.add('hidden');
    });
    drawerMenulinks.forEach((link,index)=>{
        link.addEventListener('click', event =>{
            miniSubmenuContainer.innerHTML='';
            if ((window.innerWidth >= 990) && (window.innerWidth <= 1300)) {
                // event.preventDefault();
                
                drawerDetails.forEach((targetDetail) => {
                    targetDetail.addEventListener("click", () => {
                    drawerDetails.forEach((detail) => {
                        if (detail !== targetDetail) {
                        detail.removeAttribute("open");
                        }
                    });
                    });
                });
                if(link.parentNode.hasAttribute('open')){
                }else{
                    drawerSubmenus[index].classList.remove('hidden');
                    let clonedNode = drawerSubmenus[index].cloneNode(true);
                    drawerSubmenus[index].classList.add('hidden');
                    miniSubmenuContainer.appendChild(clonedNode);
                }
            }else{
                drawerSubmenus.forEach( drawer => {
                    drawer.classList.remove('hidden');
                });
            }
        });
    })
    
    
    document.querySelector('.header__icon--summary').addEventListener('click', event => {
        miniSubmenuContainer.innerHTML='';
    })
}

    // window.addEventListener('resize', event => {
    //     drawerDetails.forEach((detail) => {
    //         detail.removeAttribute("open");
    //     });
    //         miniSubmenuContainer.innerHTML='';
    // });

window.addEventListener('resize', event => {

    if ((window.innerWidth >= 990) && (window.innerWidth <= 1250)) {
    //     drawerDetails.forEach((detail) => {
    //         detail.removeAttribute("open");
    //     });
    }else{
        drawerDetails.forEach((detail) => {
            detail.removeAttribute("open");
        });
            miniSubmenuContainer.innerHTML='';
    }
    
});














// window.addEventListener('resize', event => {
//     if ((window.innerWidth >= 990) && (window.innerWidth <= 1250)) {
//         drawerSubmenus.forEach( drawer => {
//             drawer.classList.add('hidden');
//         });
//         drawerMenulinks.forEach((link,index)=>{
//             link.addEventListener('click', event =>{
//                 miniSubmenuContainer.innerHTML='';
//                 drawerDetails.forEach((targetDetail) => {
//                     targetDetail.addEventListener("click", () => {
//                       // Close all the details that are not targetDetail.
//                       drawerDetails.forEach((detail) => {
//                         if (detail !== targetDetail) {
//                           detail.removeAttribute("open");
//                         }
//                       });
//                     });
//                   });
//                 if(link.parentNode.hasAttribute('open')){
//                 }else{
//                     drawerSubmenus[index].classList.remove('hidden');
//                     let clonedNode = drawerSubmenus[index].cloneNode(true);
//                     drawerSubmenus[index].classList.add('hidden');
//                     miniSubmenuContainer.appendChild(clonedNode);
//                     console.log(1)
//                 }
        
//             });
//         })
        
        
//         document.querySelector('.header__icon--summary').addEventListener('click', event => {
//             miniSubmenuContainer.innerHTML='';
//         })
//     }else{
//         drawerSubmenus.forEach( drawer => {
//             drawer.classList.remove('hidden');
//         });
//         drawerMenulinks.forEach((link,index)=>{
//             link.removeEventListener()
//         })
//     }
    
// });
